<template>
  <div class="item-content-raw">
    <div class="item-content" v-for="item in rawData" :key="item.id">
      <div class="item"
        @click="confirmMessage(4, item.attachments)"
        v-if="item.itemType === 3">
        <p v-html="item.title"></p>
      </div>
      <div class="item"
        @click="onClick(item)"
        v-else>
        <p v-html="item.title"></p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PageLinkTemplate',
  props: {
    // 数据源
    rawData: {
      type: Array,
      default: () => []
    },
    // 底部信息
    bottomInfo: {
      type: Array,
      default: () => []
    },
    // 跳转函数
    onClick: {
      type: Function,
      default: function () {}
    }
  },
  data () {
    return {}
  },
  methods: {
    confirmMessage (attachmentType, attachmentList) {
      let attachmentName
      let attachmentId
      let attachmentPath
      for (let e of attachmentList) {
        if (e.attachmentType === attachmentType) {
          attachmentName = e.name
          attachmentId = e.id
          attachmentPath = e.path
          break
        }
      }
      if (attachmentName) {
        let fileFormat = attachmentName.substr(attachmentName.lastIndexOf('.')).toLowerCase()
        if (fileFormat === '.pdf' || fileFormat === '.doc' || fileFormat === '.docx' || fileFormat === '.ppt' || fileFormat === '.pptx') {
          this.$nextTick(() => {
            this.$router.push({
              name: 'FileConvertedImage',
              query: {
                attachmentId: attachmentId,
                attachmentPath: attachmentPath,
                title: attachmentName
              }
            })
          })
        } else {
          this.$refs['fileLink' + attachmentId][0].click()
          return false
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/theme/_default_variables";
  * {
    box-sizing: border-box;
  }
  .item-content {
    padding: $padding-container / 2;
    padding-bottom: 0;
  }
  .item {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 0.133rem 0.267rem;
    font-size: 0.373rem;
    color: $content-background-color;
    background-color: $content-background-color-blue;
    border-radius: 0.267rem;
    p {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/PageLinkTemplate.vue